/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_ListInputs */

const en_back_to_list = /** @type {(inputs: Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to List`)
};

const de_back_to_list = /** @type {(inputs: Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Liste`)
};

/**
* | output |
* | --- |
* | "Back to List" |
*
* @param {Back_To_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const back_to_list = /** @type {((inputs?: Back_To_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_back_to_list(inputs)
	return en_back_to_list(inputs)
});